module.exports = __webpack_public_path__ + "static/media/bordnamona.764da3e8.png";